<template lang="pug">
    el-button.ButtonNext(@click="next" type="success" :disabled="disabled")  Revisar
</template>
<script>

import { mapActions } from 'vuex';

export default {
  name: 'ButtonNext',  
  methods: {    
    ...mapActions(['nextStepSCORM']),
    next() {
      this.$emit('next');
      this.nextStepSCORM();
    }
  },
  props: {        
    disabled: {
      type: Boolean,
      default: false
    }    
  }
}
</script>

<style scoped>
@import 'button-send.scss';
</style>

